export default __webpack_public_path__ + "static/media/ArrowDown.49a3fba0.svg";